import type { AnchorHTMLAttributes, ReactNode } from 'react'
import {
  Link as RouterLink,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom'

export { useParams }

export const isSpaRuntime = true

type AppLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href?: string
  to?: string
  children: ReactNode
}

export function Link({ href, to, children, ...rest }: AppLinkProps) {
  return (
    <RouterLink to={href ?? to ?? '/'} {...rest}>
      {children}
    </RouterLink>
  )
}

export function usePathname(): string {
  return useLocation().pathname
}

export function useRouter() {
  const navigate = useNavigate()
  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
  }
}
